/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { forkJoin, Observable, of, ReplaySubject } from 'rxjs';
import moment from 'moment';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { catchError, debounceTime, distinctUntilChanged, filter, map, startWith, switchMap } from 'rxjs/operators';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { SaveFilterComponent } from 'app/components/datagrid/save-filter.component';
import { HotToastService } from '@ngneat/hot-toast';
import { DispatchFilterOptions } from '../../../../../dispatch-board/src/app/components/dispatch-filter/dispatch-filter.interface';
import { MatChipInputEvent } from '@angular/material/chips';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CalendarService } from '../services/calendar.service';
import { AnalyticsService } from 'app/core/services/analytics/analytics.service';

@Component({
  selector: 'app-calendar-filter',
  templateUrl: './calendar-filter.component.html',
  styleUrls: ['./calendar-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalendarFilterComponent implements OnInit, OnChanges {
  @Input() jobCalendarFilterValues: any = null;
  @Input() hideSaveFilter: boolean;
  @Input() filterOptions: DispatchFilterOptions;
  @Input() filterFormGroup: UntypedFormGroup;
  @Input() isNewFilter: boolean = false;
  @Input() saveFilterByDefault: boolean;
  @Input() dateRange: { fromDate: string; toDate: string } = null;
  @Output() filterEmitter: EventEmitter<any> = new EventEmitter();
  jobFilterForm: UntypedFormGroup;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  filterForm: UntypedFormGroup;
  isLoaded: boolean = true;
  dateFormat: 'DD/MM/YYYY';
  filterAPIUrls: any = null;
  jobsCategory: any[] = [];
  skills: any[] = [];
  jobsStatuses: any[] = [];
  isAnyStatus: boolean = false;
  dateTypes: any[] = [{
    dateType: 'Any',
    dateKey: 'ANY'
  }, {
    dateType: 'Today',
    dateKey: 'TODAY',
    dateValue: [moment(), moment()]
  }, {
    dateType: 'Tomorrow',
    dateKey: 'TOMORROW',
    dateValue: [moment().add(1, 'days'), moment().add(1, 'days')]
  }, {
    dateType: 'This Week',
    dateKey: 'WEEK',
    dateValue: [moment().startOf('week'), moment().endOf('week')]
  }, {
    dateType: 'This Month',
    dateKey: 'MONTH',
    dateValue: [moment().startOf('month'), moment().endOf('month')]
  }, {
    dateType: 'Custom Range',
    dateKey: 'CUSTOM'
  }];
  priorityTypes: any[] = [{
    priorityType: 'All',
    priorityKey: 'ALL'
  }, {
    priorityType: 'Low',
    priorityKey: 'LOW'
  }, {
    priorityType: 'Medium',
    priorityKey: 'MEDIUM'
  }, {
    priorityType: 'High',
    priorityKey: 'HIGH'
  }, {
    priorityType: 'Urgent',
    priorityKey: 'URGENT'
  }];
  assignedStatus: any[] = [
    {
      assignedType: 'Any',
      assignedKey: ''
    },
    {
      assignedType: 'Assigned',
      assignedKey: 'ASSIGNED'
    }, {
      assignedType: 'Unassigned',
      assignedKey: 'UNASSIGNED'
    }];
  customers: Observable<any[]> = new Observable<any[]>();
  customerValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  customerFetching: boolean = false;
  customerParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  customerPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  customerOptions: any[] = [];
  organizationFetching: boolean = false;
  organizationParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  organizationPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  organizationValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  organizationOptions: any[] = [];
  organizations: Observable<any[]> = new Observable<any[]>();
  teamFetching: boolean = false;
  teamParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  teamPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  teamValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  teamOptions: any[] = [];
  teams: Observable<any[]> = new Observable<any[]>();
  employeeFetching: boolean = false;
  employeeParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  employeePagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  employeeValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  employeeOptions: any[] = [];
  employees: Observable<any[]> = new Observable<any[]>();
  projectFetching: boolean = false;
  projectParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  projectPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  projectValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  projectOptions: any[] = [];
  projects: Observable<any[]> = new Observable<any[]>();
  tagFetching: boolean = false;
  tagParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  tagPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  tagValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  tagOptions: any[] = [];
  tags: Observable<any[]> = new Observable<any[]>();
  propertyFetching: boolean = false;
  propertyParamObj: any = {
    'count': 10,
    'page': 1,
    'filter.is_active': true
  };
  propertyPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  tagsOption: any = {
    module: 'JOB'
  };
  moduleId: any;
  saveAsFilter: boolean = false;
  propertyValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  propertyOptions: any[] = [];
  properties: Observable<any[]> = new Observable<any[]>();
  constructor(
    private dataCollectorService: DataCollectorService,
    private calendarService: CalendarService,
    private utilityService: UtilityService,
    private zuperDialogService: ZuperDialogService,
    private toast: HotToastService,
    private _analytics: AnalyticsService,
    public _localStorageService: LocalStorageService) {
    this.createFilterForm();
  }

  createFilterForm(): void {
    this.jobFilterForm = new UntypedFormGroup({
      routeName: new UntypedFormControl(null),
      routeOptimized: new UntypedFormControl(false),
      routeDateFrom: new UntypedFormControl(null),
      routeDateTo: new UntypedFormControl(null),
      jobSearch: new UntypedFormControl(null),
      jobCategory: new UntypedFormControl([]),
      jobStatus: new UntypedFormControl([]),
      dueDateType: new UntypedFormControl('ANY'),
      dueDateFrom: new UntypedFormControl(null),
      dueDateTo: new UntypedFormControl(null),
      scheduleDateType: new UntypedFormControl('ANY'),
      scheduleDateFrom: new UntypedFormControl(null),
      scheduleDateTo: new UntypedFormControl(null),
      skills: new UntypedFormControl([]),
      territory: new UntypedFormControl([]),
      priority: new UntypedFormControl(null),
      assigned: new UntypedFormControl(null),
      tags: new UntypedFormControl([]),
      customer: new UntypedFormControl([]),
      organization: new UntypedFormControl([]),
      team: new UntypedFormControl([]),
      employee: new UntypedFormControl([]),
      property: new UntypedFormControl([]),
      project:  new UntypedFormControl([]),
    });
  }

  ngOnInit(): void {
    this.filterAPIUrls = this.calendarService.filterAPIurls;
    this.hideSaveFilter = this.hideSaveFilter ?? false;
    this.dateFormat = this.utilityService.dateFormat;
    this.saveAsFilter = this.saveFilterByDefault;
    this.moduleId = this._localStorageService.getLocalStorage('company_modules')?.find((data: any) => data?.module?.module_key === this.tagsOption.module)?.module?.module_uid;
    if (this.filterFormGroup) {
      this.filterFormGroup.addControl('filterOptions', this.jobFilterForm);
    }
    this.getJobCommonData();
  }

  getJobCommonData(): void {
    this.isLoaded = false;
    forkJoin([this.dataCollectorService.getData(this.filterAPIUrls.jobCategoryUrl),
    this.dataCollectorService.getData(this.filterAPIUrls.skillsUrl)
    ]).subscribe(([categories, skills]) => {
      this.isLoaded = true;
      this.jobsCategory = categories.data;
      this.jobsCategory.forEach((category: any) => category['selectedAllCategories'] = 'selectedAllCategories');
      this.skills = skills.data;
      this.getCombinedData();
    }, (error: any) => {
      this.isLoaded = true;
      this.getCombinedData();
    });
  }

  getCombinedData(): void{
    this.setFilterFormValue();
    this.getTeam();
    this.getEmployee();
    this.getCustomer();
    this.getOrganization();
    this.getTag();
    this.getProperty();
    this.getProject();
  }

  setFilterFormValue(): void {
    if (!this.isNewFilter && this.jobCalendarFilterValues) {
      let filterValues;
      if (this.jobCalendarFilterValues) {
         filterValues = this.jobCalendarFilterValues.filterOptions
          ? this.jobCalendarFilterValues.filterOptions
          : this.jobCalendarFilterValues;
      }
      this.setJobFilterValue(filterValues);
    } else {
      this.resetFilter();
    }
  }

  setJobFilterValue(filterValue: any): void {
    const jobCategories: string[] = filterValue?.['filter.job_category']?.length ? this.convertStringToArray(filterValue?.['filter.job_category']) : [];
    const jobFilterValue: any = {
      jobSearch: filterValue?.['filter.keyword'] || '',
      jobCategory: jobCategories.length ? jobCategories : [],
      jobStatus: filterValue?.['filter.job_status']?.length ? this.convertStringToArray(filterValue?.['filter.job_status']) : [],
      dueDateFrom: filterValue?.['filter.due_date_from'] ? moment(filterValue?.['filter.due_date_from']) : null,
      dueDateTo: filterValue?.['filter.due_date_to'] ? moment(filterValue?.['filter.due_date_to']) : null,
      scheduleDateFrom: filterValue?.['filter.from_date'] ? moment(filterValue?.['filter.from_date']) : null,
      scheduleDateTo: filterValue?.['filter.to_date'] ? moment(filterValue?.['filter.to_date']) : null,
      skills: filterValue?.['filter.skillset_uid']?.length ? this.convertStringToArray(filterValue?.['filter.skillset_uid']) : [],
      territory: filterValue?.['filter.service_territory']?.length ? this.convertStringToArray(filterValue?.['filter.service_territory']) : [],
      priority: filterValue?.['filter.priority'] || null,
      assigned: filterValue?.['filter.assigned'] || null,
      tags: filterValue?.['filter.job_tags']?.length ? this.convertStringToArray(filterValue?.['filter.job_tags']) : [],
      dueDateType: filterValue?.['due_date_type'] || null,
      scheduleDateType: filterValue?.['schedule_date_type'] || null,
      customer: filterValue?.['filter.customer']?.length ? this.convertStringToArray(filterValue?.['filter.customer']) : [],
      organization: filterValue?.['filter.customer_organization']?.length ? this.convertStringToArray(filterValue?.['filter.customer_organization']) : [],
      property: filterValue?.['filter.property']?.length ? this.convertStringToArray(filterValue?.['filter.property']) : [],
      team: filterValue?.['filter.assigned_to_team']?.length ? this.convertStringToArray(filterValue?.['filter.assigned_to_team']) : [],
      employee: filterValue?.['filter.assigned_to']?.length ? this.convertStringToArray(filterValue?.['filter.assigned_to']) : [],
      project: filterValue?.['filter.project']?.length ? this.convertStringToArray(filterValue?.['filter.project']) : [],
    };
    this.jobsStatuses = jobCategories.length > 0 ? this.getSelectedCategoriesStatus(jobCategories) : [];
    let selectedStatusItems: string[] = [];
    if (filterValue) {
        const statusFilter = filterValue['filter.job_status'];
        if (statusFilter) {
            selectedStatusItems = statusFilter.split(',').map(id => id.trim());
        }
    }
    this.isAnyStatus = (jobCategories?.length > 0  && this.jobsStatuses?.length !== 0) ? selectedStatusItems?.length === this.jobsStatuses.length : false;
    this.jobFilterForm.patchValue(jobFilterValue);
  }

  //#region Jobs
  changeJobCategory(items: any): void {
    if (items.length === 1 && items[0]?.selectedAllCategories && !items[0]?.category_uid) {
      this.jobFilterForm.get('jobCategory').setValue(this.jobsCategory.map((category: any) => category.category_uid));
    }
    if (items.length > 0) {
      const selectedCategories: any[] = this.jobFilterForm.get('jobCategory')?.value ?? [];
      this.jobsStatuses = selectedCategories.length > 0 ? this.getSelectedCategoriesStatus(selectedCategories) : [];
      let selectedItems = this.jobFilterForm.get('jobStatus').value;
      if(selectedItems.length > 0){
        const filteredStatusArray = this.jobsStatuses.filter(obj => selectedItems.includes(obj.status_uid));
        selectedItems = filteredStatusArray.map((status: any) => status.status_uid);
      }
      this.jobFilterForm.get('jobStatus').setValue(selectedItems);
    } else {
      this.jobsStatuses = [];
      this.jobFilterForm.get('jobStatus').setValue([]);
    }
    const selectedStatusItems = this.jobFilterForm.get('jobStatus').value;
    if(this.jobsStatuses.length !== 0 && (this.jobsStatuses.length === selectedStatusItems.length)){
      this.isAnyStatus = true;
    } else{
      this.isAnyStatus = false;
    }
  }

  getSelectedCategoriesStatus(selectedCategories: any[]): any[] {
    let status: any[] = [];
    selectedCategories.forEach((sCategory: any) => {
      const category: any = this.jobsCategory.find((jCategory: any) => jCategory.category_uid === sCategory);
      if (category?.job_statuses?.length) {
        category?.job_statuses.forEach((cStatus: any) => {
          cStatus['category_name'] = category.category_name;
          cStatus['category_uid'] = category.category_uid;
        });
        status = status.concat(category?.job_statuses);
      }
    });
    return status;
  }

  convertStringToArray(value: string): string[] {
    return value ? value.split(',') : [];
  }

  resetFilterPanel(): void {
    this._localStorageService.removeLocalStorage('job_calendar_filter');
    this.resetFilter();
    const filterValues: any = this.getFilterValues();
    this.filterEmitter.emit({
      isClosed: true,
      filter: filterValues,
      type: 'reset'
    });
  }

  applyFilter(): void {
    const filterValues: any = this.getFilterValues();
    if (this.saveAsFilter) {
      this.saveFilterAction(filterValues);
    } else {
      this.saveFilter(filterValues);
    }
  }

  changeDueDateType(items: any): void {
    this.jobFilterForm.patchValue({
      dueDateFrom: items?.dateValue?.[0] ?? '',
      dueDateTo: items?.dateValue?.[1] ?? ''
    });
  }

  UpdatefieldModelValue(event): void {
    this.jobFilterForm.get('tags').setValue(event);
  }

  setAnyJobStatus(event: any): void {
    event.stopPropagation();
    if (event?.target?.checked) {
      this.isAnyStatus = true;
      this.jobFilterForm.get('jobStatus').setValue(this.jobsStatuses.map((status: any) => status.status_uid));
    } else{
      this.jobFilterForm.get('jobStatus').setValue([]);
      this.isAnyStatus = false;
    }
  }

  changeJobStatus(items: any): void {
    const selectedStatusItems = this.jobFilterForm.get('jobStatus').value;
    if(this.jobsStatuses.length === selectedStatusItems.length){
      this.isAnyStatus = true;
    } else{
      this.isAnyStatus = false;
    }
  }

  saveFilter(filterValues, filter_uid?: any): any {
    this._localStorageService.setLocalStorage('job_calendar_filter', this.getFilterValues());
    this.filterEmitter.emit({
      isClosed: true,
      filter: filterValues,
      type: 'apply',
      filter_uid: filter_uid
    });
  }

  //#region Save As Filter
  saveFilterAction(filterValues: any): void {
    const dialogRef = this.zuperDialogService.openCustom(SaveFilterComponent,
      {
        dismissible: false,
        extraClass: 'dispatch-save-filter',
      });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result.cancel) {
        this._analytics.trackEvent('web_calendar_advanced_filter_save_as_filter_checkbox_clicked');
        const filterPayload = {
          quick_filter: {
            filter_applicability: result.filter_applicability,
            filter_name: result.filter_name,
            filter_options: filterValues,
            module_name: "JOB_CALENDAR"
          }
        };
        if (result.filter_applicability === 'USERS') {
          filterPayload.quick_filter['filter_applicable_to_users'] = result.value;
        } else if (result.filter_applicability === 'TEAMS') {
          filterPayload.quick_filter['filter_applicable_to_teams'] = result.value;
        }
        this.toast.loading('Saving New Filter', { id: 'save_dispatch_filter' });
        this.dataCollectorService.postData(this.filterAPIUrls.saveFilterUrl, filterPayload).subscribe((response: any) => {
          this.toast.close('save_dispatch_filter');
          this.toast.success(response.message);
          this.saveFilter(filterValues, response.data?.filter_uid);
        }, (error: any) => {
          this.toast.close('save_dispatch_filter');
        });
      }
    });
  }

  closeFilterPanel(): void {
    this.filterEmitter.emit({ isClosed: false });
  }

  resetFilter(): void {
    this.jobFilterForm.reset({
      jobs: {
        routeName: null,
        routeOptimized: false,
        routeDateFrom: null,
        routeDateTo: null,
        jobCategory: [],
        jobStatus: [],
        dueDateType: 'ANY',
        dueDateFrom: null,
        dueDateTo: null,
        scheduleDateType: 'ANY',
        scheduleDateFrom: null,
        scheduleDateTo: null,
        skills: [],
        territory: [],
        priority: null,
        tags: [],
        customer: [],
        organization: [],
        property: []
      }
    });
  }

  getFilterValues(): any {
    const filterValue = this.jobFilterForm.value;
    const calendarFilterValue = {
      'filter.keyword': filterValue.jobSearch ?? '',
      'filter.job_category': filterValue.jobCategory?.toString() ?? '',
      'filter.job_status': filterValue.jobStatus?.toString() ?? '',
      'filter.due_date_from': '',
      'filter.due_date_to': '',
      'filter.from_date': '',
      'filter.to_date': '',
      'filter.skillset_uid': filterValue.skills?.toString() ?? '',
      'filter.service_territory': filterValue.territory?.toString() ?? '',
      'filter.priority': '',
      'filter.assigned':  filterValue.assigned?.toString() ?? '',
      'filter.job_tags': filterValue.tags?.toString() ?? '',
      'due_date_type': filterValue.dueDateType ?? 'ANY',
      'filter.customer': filterValue.customer?.toString() ?? '',
      'filter.customer_organization': filterValue.organization?.toString() ?? '',
      'filter.property': filterValue.property?.toString() ?? '',
      'filter.assigned_to_team': filterValue.team?.toString() ?? '',
      'filter.assigned_to': filterValue.employee?.toString() ?? ''
    };

    if (filterValue?.dueDateFrom?.format) {
      calendarFilterValue['filter.due_date_from'] = filterValue?.dueDateFrom?.format('YYYY-MM-DD');
    }
    if (filterValue?.dueDateTo?.format) {
      calendarFilterValue['filter.due_date_to'] = filterValue?.dueDateTo?.format('YYYY-MM-DD');
    }
    if (filterValue.priority && filterValue.priority !== 'ALL') {
      calendarFilterValue['filter.priority'] = filterValue.priority;
    }
    if (filterValue?.project) {
      calendarFilterValue['filter.project'] = filterValue.project?.toString() ?? '';
    }
    return calendarFilterValue;
  }

  getCustomer(): void {
    if (this.jobFilterForm.value?.customer?.length) {
      this.customerFetching = true;
      this.customerParamObj['filter.customer_uid'] = this.jobFilterForm.value?.customer?.toString() || '';
    }
    const urlParams = this.utilityService.constructParam(this.customerParamObj);
    this.dataCollectorService.getData(this.filterAPIUrls.customerUrl, urlParams).subscribe((response: any) => {
      this.customerOptions = response.data;
      this.customerPagination.loadingIndex = response.current_page;
      this.customerPagination.totalPage = response.total_pages;
      this.customers = this.jobFilterForm.get('customer').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.customerOptions)
      );
      delete this.customerParamObj['filter.customer_uid'];
      this.customerFetching = false;
    });
  }

  onCustomerSearch(): void {
    this.customers = this.customerValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getCustomers(term))
    );
  }

  onCustomerClear(): void {
    this.customers = this.getCustomers('');
  }

  getCustomers(input): Observable<any[]> {
    this.customerPagination.keyword = input ? input : '';
    this.customerParamObj['filter.keyword'] = this.customerPagination.keyword;
    this.customerParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.customerParamObj);
    this.customerFetching = true;
    return this.dataCollectorService.getData(this.filterAPIUrls.customerUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.customerPagination.loadingIndex = response.current_page;
          this.customerPagination.totalPage = response.total_pages;
          this.customerOptions = response.data;
          this.customerFetching = false;
          return response.data;
        }),
      );
  }

  onCustomerScrollToEnd(): void {
    if (this.customerPagination.loadingIndex < this.customerPagination.totalPage) {
      this.customerPagination.loadingIndex++;
      this.customerParamObj['filter.keyword'] = this.customerPagination.keyword;
      this.customerParamObj['page'] = this.customerPagination.loadingIndex;
      this.customerFetching = true;
      const urlParams = this.utilityService.constructParam(this.customerParamObj);
      this.dataCollectorService.getData(this.filterAPIUrls.customerUrl, urlParams).subscribe(
        (response: any) => {
          this.customerFetching = false;
          this.customerOptions = this.customerOptions.concat(response.data);
          this.customers = this.jobFilterForm.get('customer').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.customerOptions)
          );
        }, (error: any) => {
          this.customerFetching = false;
        });
    }
  }

  getOrganization(): void {
    if (this.jobFilterForm.value?.organization?.length) {
      this.organizationFetching = true;
      this.organizationParamObj['filter.organization_uid'] = this.jobFilterForm.value?.organization?.toString() || '';
    }
    const urlParams = this.utilityService.constructParam(this.organizationParamObj);
    this.dataCollectorService.getData(this.filterAPIUrls.organizationUrl, urlParams).subscribe((response: any) => {
      this.organizationOptions = response.data;
      this.organizationPagination.loadingIndex = response.current_page;
      this.organizationPagination.totalPage = response.total_pages;
      this.organizations = this.jobFilterForm.get('organization').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.organizationOptions)
      );
      delete this.organizationParamObj['filter.organization_uid'];
      this.organizationFetching = false;
    });
  }

  onOrganizationSearch(): void {
    this.organizations = this.organizationValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getOrganizations(term))
    );
  }

  onOrganizationClear(): void {
    this.organizations = this.getOrganizations('');
  }

  onOrganizationScrollToEnd(): void {
    if (this.organizationPagination.loadingIndex < this.organizationPagination.totalPage) {
      this.organizationPagination.loadingIndex++;
      this.organizationParamObj['filter.keyword'] = this.organizationPagination.keyword;
      this.organizationParamObj['page'] = this.organizationPagination.loadingIndex;
      this.organizationFetching = true;
      const urlParams = this.utilityService.constructParam(this.organizationParamObj);
      this.dataCollectorService.getData(this.filterAPIUrls.organizationUrl, urlParams).subscribe(
        (response: any) => {
          this.organizationFetching = false;
          this.organizationOptions = this.organizationOptions.concat(response.data);
          this.organizations = this.jobFilterForm.get('organization').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.organizationOptions)
          );
        }, (error: any) => {
          this.organizationFetching = false;
        });
    }
  }

  getOrganizations(input: string): Observable<any[]> {
    this.organizationPagination.keyword = input ? input : '';
    this.organizationParamObj['filter.keyword'] = this.organizationPagination.keyword;
    this.organizationParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.organizationParamObj);
    this.organizationFetching = true;
    return this.dataCollectorService.getData(this.filterAPIUrls.organizationUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.organizationPagination.loadingIndex = response.current_page;
          this.organizationPagination.totalPage = response.total_pages;
          this.organizationOptions = response.data;
          this.organizationFetching = false;
          return response.data;
        }),
      );
  }

  getTeam(): void {
    if (this.jobFilterForm.value?.team?.length) {
      this.teamFetching = true;
      this.teamParamObj['filter.team_uid'] = this.jobFilterForm.value?.team?.toString() || '';
    }
    const urlParams = this.utilityService.constructParam(this.teamParamObj);
    this.dataCollectorService.getData(this.filterAPIUrls.teamUrl, urlParams).subscribe((response: any) => {
      this.teamOptions = response.data;
      this.teamPagination.loadingIndex = response.current_page;
      this.teamPagination.totalPage = response.total_pages;
      this.teams = this.jobFilterForm.get('team').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.teamOptions)
      );
      delete this.teamParamObj['filter.team_uid'];
      this.teamFetching = false;
    });
  }

  onTeamSearch(): void {
    this.teams = this.teamValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getTeams(term))
    );
  }

  onTeamClear(): void {
    this.teams = this.getTeams('');
  }

  onTeamScrollToEnd(): void {
    if (this.teamPagination.loadingIndex < this.teamPagination.totalPage) {
      this.teamPagination.loadingIndex++;
      this.teamParamObj['filter.keyword'] = this.teamPagination.keyword;
      this.teamParamObj['page'] = this.teamPagination.loadingIndex;
      this.teamFetching = true;
      const urlParams = this.utilityService.constructParam(this.teamParamObj);
      this.dataCollectorService.getData(this.filterAPIUrls.teamUrl, urlParams).subscribe(
        (response: any) => {
          this.teamFetching = false;
          this.teamOptions = this.teamOptions.concat(response.data);
          this.teams = this.jobFilterForm.get('team').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.teamOptions)
          );
        }, (error: any) => {
          this.teamFetching = false;
        });
    }
  }

  getTeams(input: string): Observable<any[]> {
    this.teamPagination.keyword = input ? input : '';
    this.teamParamObj['filter.keyword'] = this.teamPagination.keyword;
    this.teamParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.teamParamObj);
    this.teamFetching = true;
    return this.dataCollectorService.getData(this.filterAPIUrls.teamUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.teamPagination.loadingIndex = response.current_page;
          this.teamPagination.totalPage = response.total_pages;
          this.teamOptions = response.data;
          this.teamFetching = false;
          return response.data;
        }),
      );
  }

  getEmployee(): void {
    if (this.jobFilterForm.value?.employee?.length) {
      this.employeeFetching = true;
      this.employeeParamObj['filter.user_uid'] = this.jobFilterForm.value?.employee?.toString() || '';
    }
    const urlParams = this.utilityService.constructParam(this.employeeParamObj);
    this.dataCollectorService.getData(this.filterAPIUrls.employeeUrl, urlParams).subscribe((response: any) => {
      this.employeeOptions = response.data;
      this.employeePagination.loadingIndex = response.current_page;
      this.employeePagination.totalPage = response.total_pages;
      this.employees = this.jobFilterForm.get('employee').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.employeeOptions)
      );
      delete this.employeeParamObj['filter.user_uid'];
      this.employeeFetching = false;
    });
  }

  onEmployeeSearch(): void {
    this.employees = this.employeeValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getEmployees(term))
    );
  }

  onEmployeeClear(): void {
    this.employees = this.getEmployees('');
  }

  onEmployeeScrollToEnd(): void {
    if (this.employeePagination.loadingIndex < this.employeePagination.totalPage) {
      this.employeePagination.loadingIndex++;
      this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
      this.employeeParamObj['page'] = this.employeePagination.loadingIndex;
      this.employeeFetching = true;
      const urlParams = this.utilityService.constructParam(this.employeeParamObj);
      this.dataCollectorService.getData(this.filterAPIUrls.employeeUrl, urlParams).subscribe(
        (response: any) => {
          this.employeeFetching = false;
          this.employeeOptions = this.employeeOptions.concat(response.data);
          this.employees = this.jobFilterForm.get('employee').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.employeeOptions)
          );
        }, (error: any) => {
          this.employeeFetching = false;
        });
    }
  }

  getEmployees(input: string): Observable<any[]> {
    this.employeePagination.keyword = input ? input : '';
    this.employeeParamObj['filter.keyword'] = this.employeePagination.keyword;
    this.employeeParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.employeeParamObj);
    this.employeeFetching = true;
    return this.dataCollectorService.getData(this.filterAPIUrls.employeeUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.employeePagination.loadingIndex = response.current_page;
          this.employeePagination.totalPage = response.total_pages;
          this.employeeOptions = response.data;
          this.employeeFetching = false;
          return response.data;
        }),
      );
  }

  getTag(): void {
    if (this.jobFilterForm.value?.tags?.length) {
      this.tagFetching = true;
      this.tagParamObj['filter.tag_uid'] = this.jobFilterForm.value?.tags?.toString() || '';
    }
    this.tagParamObj['filter.module'] = this.moduleId;
    const urlParams = this.utilityService.constructParam(this.tagParamObj);
    this.dataCollectorService.getData(this.filterAPIUrls.tagUrl, urlParams).subscribe((response: any) => {
      this.tagOptions = response.data;
      this.tagPagination.loadingIndex = response.current_page;
      this.tagPagination.totalPage = response.total_pages;
      this.tags = this.jobFilterForm.get('tags').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.tagOptions)
      );
      delete this.tagParamObj['filter.tag_uid'];
      this.tagFetching = false;
    });
  }

  onTagSearch(): void {
    this.tags = this.tagValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getTags(term))
    );
  }

  onTagClear(): void {
    this.tags = this.getTags('');
  }

  onTagScrollToEnd(): void {
    if (this.tagPagination.loadingIndex < this.tagPagination.totalPage) {
      this.tagPagination.loadingIndex++;
      this.tagParamObj['filter.keyword'] = this.tagPagination.keyword;
      this.tagParamObj['page'] = this.tagPagination.loadingIndex;
      this.tagParamObj['filter.module'] = this.moduleId;
      this.tagFetching = true;
      const urlParams = this.utilityService.constructParam(this.tagParamObj);
      this.dataCollectorService.getData(this.filterAPIUrls.tagUrl, urlParams).subscribe(
        (response: any) => {
          this.tagFetching = false;
          this.tagOptions = this.tagOptions.concat(response.data);
          this.tags = this.jobFilterForm.get('tags').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.tagOptions)
          );
        }, (error: any) => {
          this.tagFetching = false;
        });
    }
  }

  getTags(input: string): Observable<any[]> {
    this.tagPagination.keyword = input ? input : '';
    this.tagParamObj['filter.keyword'] = this.tagPagination.keyword;
    this.tagParamObj['page'] = 1;
    this.tagParamObj['filter.module'] = this.moduleId;
    const urlParams = this.utilityService.constructParam(this.tagParamObj);
    this.tagFetching = true;
    return this.dataCollectorService.getData(this.filterAPIUrls.tagUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.tagPagination.loadingIndex = response.current_page;
          this.tagPagination.totalPage = response.total_pages;
          this.tagOptions = response.data;
          this.tagFetching = false;
          return response.data;
        }),
      );
  }

  getProperty(): void {
    if (this.jobFilterForm.value?.property?.length) {
      this.propertyFetching = true;
      this.propertyParamObj['filter.property_uid'] = this.jobFilterForm.value?.property?.toString() || '';
    }
    const urlParams = this.utilityService.constructParam(this.propertyParamObj);
    this.dataCollectorService.getData(this.filterAPIUrls.propertyUrl, urlParams).subscribe((response: any) => {
      this.propertyOptions = response.data;
      this.propertyPagination.loadingIndex = response.current_page;
      this.propertyPagination.totalPage = response.total_pages;
      this.properties = this.jobFilterForm.get('property').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.propertyOptions)
      );
      delete this.propertyParamObj['filter.property_uid'];
      this.propertyFetching = false;
    });
  }

  onPropertySearch(): void {
    this.properties = this.propertyValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getProperties(term))
    );
  }

  onPropertyClear(): void {
    this.properties = this.getProperties('');
  }

  onPropertyScrollToEnd(): void {
    if (this.propertyPagination.loadingIndex < this.propertyPagination.totalPage) {
      this.propertyPagination.loadingIndex++;
      this.propertyParamObj['filter.keyword'] = this.propertyPagination.keyword;
      this.propertyParamObj['page'] = this.propertyPagination.loadingIndex;
      this.propertyFetching = true;
      const urlParams = this.utilityService.constructParam(this.propertyParamObj);
      this.dataCollectorService.getData(this.filterAPIUrls.propertyUrl, urlParams).subscribe(
        (response: any) => {
          this.propertyFetching = false;
          this.propertyOptions = this.propertyOptions.concat(response.data);
          this.properties = this.jobFilterForm.get('property').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.propertyOptions)
          );
        }, (error: any) => {
          this.propertyFetching = false;
        });
    }
  }

  changeScheduleDateType(items: any): void {
    this.jobFilterForm.patchValue({
      scheduleDateFrom: items?.dateValue?.[0] ?? '',
      scheduleDateTo: items?.dateValue?.[1] ?? ''
    });
  }

  getProperties(input: string): Observable<any[]> {
    this.propertyPagination.keyword = input ? input : '';
    this.propertyParamObj['filter.keyword'] = this.propertyPagination.keyword;
    this.propertyParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.propertyParamObj);
    this.propertyFetching = true;
    return this.dataCollectorService.getData(this.filterAPIUrls.propertyUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.propertyPagination.loadingIndex = response.current_page;
          this.propertyPagination.totalPage = response.total_pages;
          this.propertyOptions = response.data;
          this.propertyFetching = false;
          return response.data;
        }),
      );
  }

  removeTag(value: string, arrayValue: any[]): void {
    const index = arrayValue.indexOf(value);
    if (index >= 0) {
      arrayValue.splice(index, 1);
    }
  }

  addTag(event: MatChipInputEvent, arrayValue: any[]): void {
    if (event.value) {
      const index = arrayValue.indexOf(event.value);
      if (index === -1) {
        arrayValue.push(event.value);
      }
      event.chipInput.clear();
    }
  }

  getProject(): void {
    if (this.jobFilterForm.value?.project?.length) {
      this.projectFetching = true;
      this.projectParamObj['filter.project_uid'] = this.jobFilterForm.value?.project?.toString() || '';
    }
    const urlParams = this.utilityService.constructParam(this.projectParamObj);
    this.dataCollectorService.getData(this.filterAPIUrls.projectUrl, urlParams).subscribe((response: any) => {
      this.projectOptions = response.data;
      this.projectPagination.loadingIndex = response.current_page;
      this.projectPagination.totalPage = response.total_pages;
      this.projects = this.jobFilterForm.get('project').valueChanges.pipe(
        startWith(''),
        map((value: any) => this.projectOptions)
      );
      delete this.projectParamObj['filter.project_uid'];
      this.projectFetching = false;
    });
  }

  onProjectSearch(): void {
    this.projects = this.projectValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getProjects(term))
    );
  }

  onProjectClear(): void {
    this.projects = this.getProjects('');
  }

  onProjectScrollToEnd(): void {
    if (this.projectPagination.loadingIndex < this.projectPagination.totalPage) {
      this.projectPagination.loadingIndex++;
      this.projectParamObj['filter.keyword'] = this.projectPagination.keyword;
      this.projectParamObj['page'] = this.projectPagination.loadingIndex;
      this.projectFetching = true;
      const urlParams = this.utilityService.constructParam(this.projectParamObj);
      this.dataCollectorService.getData(this.filterAPIUrls.projectUrl, urlParams).subscribe(
        (response: any) => {
          this.projectFetching = false;
          this.projectOptions = this.projectOptions.concat(response.data);
          this.projects = this.jobFilterForm.get('project').valueChanges.pipe(
            startWith(''),
            map((value: any) => this.projectOptions)
          );
        }, (error: any) => {
          this.projectFetching = false;
        });
    }
  }

  getProjects(input: string): Observable<any[]> {
    this.projectPagination.keyword = input ? input : '';
    this.projectParamObj['filter.keyword'] = this.projectPagination.keyword;
    this.projectParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.projectParamObj);
    this.projectFetching = true;
    return this.dataCollectorService.getData(this.filterAPIUrls.projectUrl, urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.projectPagination.loadingIndex = response.current_page;
          this.projectPagination.totalPage = response.total_pages;
          this.projectOptions = response.data;
          this.projectFetching = false;
          return response.data;
        }),
      );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.jobCalendarFilterValues?.firstChange === false) {
      this.setFilterFormValue();
    }
    if (changes?.isNewFilter?.firstChange === false) {
      this.setFilterFormValue();
    }

  }
}
